import { render } from "./ProductAttributeOptionCreateComponent.vue?vue&type=template&id=05e706e4"
import script from "./ProductAttributeOptionCreateComponent.vue?vue&type=script&lang=js"
export * from "./ProductAttributeOptionCreateComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/ProductAttribute/ProductAttributeOptionCreateComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "05e706e4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('05e706e4', __exports__)) {
    api.reload('05e706e4', __exports__)
  }
  
  module.hot.accept("./ProductAttributeOptionCreateComponent.vue?vue&type=template&id=05e706e4", () => {
    api.rerender('05e706e4', render)
  })

}


export default __exports__